var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevelopmentIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.918,
    height: 63.671,
    viewBox: "0 0 63.918 63.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2c652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#1cabe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3254fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10031",
    "data-name": "Group 10031",
    transform: "translate(-393 -1595.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3339053_business_tools_wallet_e_wallet_money_parse_icon",
    "data-name": "3339053_business tools_wallet_e wallet_money_parse_icon",
    transform: "translate(393.001 1595.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7937",
    "data-name": "Path 7937",
    d: "M5.71,12.549a1.065,1.065,0,0,0-.886-1.937,8.5,8.5,0,0,0-2.04,1.311,1.066,1.066,0,0,0,1.4,1.611A6.369,6.369,0,0,1,5.71,12.549Z",
    transform: "translate(0.157 0.564)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7938",
    "data-name": "Path 7938",
    d: "M9.065,12.015H11.2a1.065,1.065,0,0,0,0-2.131H9.065a1.065,1.065,0,0,0,0,2.131Z",
    transform: "translate(0.522 0.522)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7939",
    "data-name": "Path 7939",
    d: "M15.065,12.015H17.2a1.065,1.065,0,1,0,0-2.131H15.065a1.065,1.065,0,0,0,0,2.131Z",
    transform: "translate(0.914 0.522)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7940",
    "data-name": "Path 7940",
    d: "M11.2,23.884H9.065a1.065,1.065,0,0,0,0,2.131H11.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(0.522 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7941",
    "data-name": "Path 7941",
    d: "M23.2,23.884H21.065a1.065,1.065,0,1,0,0,2.131H23.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(1.305 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7942",
    "data-name": "Path 7942",
    d: "M17.2,23.884H15.065a1.065,1.065,0,0,0,0,2.131H17.2a1.065,1.065,0,1,0,0-2.131Z",
    transform: "translate(0.914 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7943",
    "data-name": "Path 7943",
    d: "M5.71,23.42a6.384,6.384,0,0,1-1.53-.985,1.066,1.066,0,1,0-1.4,1.611,8.531,8.531,0,0,0,2.039,1.311A1.065,1.065,0,1,0,5.71,23.42Z",
    transform: "translate(0.157 1.325)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7944",
    "data-name": "Path 7944",
    d: "M29.2,23.884H27.065a1.065,1.065,0,0,0,0,2.131H29.2a1.065,1.065,0,1,0,0-2.131Z",
    transform: "translate(1.697 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7945",
    "data-name": "Path 7945",
    d: "M47.2,23.884H45.065a1.065,1.065,0,1,0,0,2.131H47.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(2.873 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7946",
    "data-name": "Path 7946",
    d: "M53.2,23.884H51.065a1.065,1.065,0,0,0,0,2.131H53.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(3.264 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7947",
    "data-name": "Path 7947",
    d: "M35.2,23.884H33.065a1.065,1.065,0,1,0,0,2.131H35.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(2.089 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7948",
    "data-name": "Path 7948",
    d: "M41.2,23.884H39.065a1.065,1.065,0,0,0,0,2.131H41.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(2.481 1.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7949",
    "data-name": "Path 7949",
    d: "M5.71,53.42a6.384,6.384,0,0,1-1.53-.985,1.066,1.066,0,1,0-1.4,1.611,8.532,8.532,0,0,0,2.039,1.311A1.065,1.065,0,0,0,5.71,53.42Z",
    transform: "translate(0.157 3.284)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7950",
    "data-name": "Path 7950",
    d: "M17.2,53.884H15.065a1.065,1.065,0,0,0,0,2.131H17.2a1.065,1.065,0,1,0,0-2.131Z",
    transform: "translate(0.914 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7951",
    "data-name": "Path 7951",
    d: "M11.2,53.884H9.065a1.065,1.065,0,0,0,0,2.131H11.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(0.522 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7952",
    "data-name": "Path 7952",
    d: "M35.2,53.884H33.065a1.065,1.065,0,1,0,0,2.131H35.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(2.089 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7953",
    "data-name": "Path 7953",
    d: "M38,54.949a1.064,1.064,0,0,0,1.065,1.065H41.2a1.065,1.065,0,0,0,0-2.131H39.065A1.064,1.064,0,0,0,38,54.949Z",
    transform: "translate(2.481 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7954",
    "data-name": "Path 7954",
    d: "M45.065,56.015H47.2a1.065,1.065,0,0,0,0-2.131H45.065a1.065,1.065,0,1,0,0,2.131Z",
    transform: "translate(2.873 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7955",
    "data-name": "Path 7955",
    d: "M29.2,53.884H27.065a1.065,1.065,0,0,0,0,2.131H29.2a1.065,1.065,0,1,0,0-2.131Z",
    transform: "translate(1.697 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7956",
    "data-name": "Path 7956",
    d: "M51.065,56.015H53.2a1.065,1.065,0,0,0,0-2.131H51.065a1.065,1.065,0,0,0,0,2.131Z",
    transform: "translate(3.264 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7957",
    "data-name": "Path 7957",
    d: "M23.2,53.884H21.065a1.065,1.065,0,0,0,0,2.131H23.2a1.065,1.065,0,0,0,0-2.131Z",
    transform: "translate(1.305 3.396)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7958",
    "data-name": "Path 7958",
    d: "M44,39.145a4.261,4.261,0,1,0,4.261-4.261A4.265,4.265,0,0,0,44,39.145Zm4.261-2.131a2.131,2.131,0,1,1-2.131,2.131A2.133,2.133,0,0,1,48.261,37.015Z",
    transform: "translate(2.873 2.155)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7959",
    "data-name": "Path 7959",
    d: "M45.746,6.261,39.955.47a1.215,1.215,0,0,0-1.714,0l-2.18,2.18L33.882.47a1.215,1.215,0,0,0-1.714,0L26.377,6.261H8.522A8.532,8.532,0,0,0,0,14.783V56.168a7.629,7.629,0,0,0,7.619,7.619h56.3V6.261H45.746ZM39.1,2.626l3.635,3.635L57.648,21.175H51.9l-12-12a1.151,1.151,0,0,0-1.618.012L26.293,21.175H20.55L37.569,4.157h0Zm9.794,18.549H29.305L39.1,11.382ZM33.024,2.626l1.531,1.531L17.537,21.175H14.475L29.39,6.261ZM8.522,8.391H24.246l-2.2,2.2a1.037,1.037,0,0,0-.674.674l-9.914,9.914H8.522a6.392,6.392,0,1,1,0-12.784ZM61.788,46.742H50.069a5.327,5.327,0,1,1,0-10.653H61.788Zm0-21.306H60.722a1.065,1.065,0,0,0,0,2.131h1.065v6.392H50.069a7.457,7.457,0,1,0,0,14.914H61.788V57.4H60.722a1.065,1.065,0,0,0,0,2.131h1.065v2.131H7.619a5.5,5.5,0,0,1-5.488-5.488V53.82A1.048,1.048,0,0,0,2.387,52.8,6.4,6.4,0,0,1,2.131,51V21.861a1.048,1.048,0,0,0,.257-1.016c-.02-.069-.028-.141-.046-.21.1.1.193.2.293.3s.186.173.282.257q.179.157.365.3c.1.079.2.154.306.229.129.093.262.18.4.265.108.068.215.134.326.2.141.08.284.154.429.227.112.056.224.113.339.164.152.067.308.127.463.185.115.044.229.088.346.127.167.054.338.1.508.143.113.029.224.063.339.087.193.042.389.069.586.1.1.014.194.034.293.045a8.508,8.508,0,0,0,.907.05H61.788ZM60.66,21.175l-8.522-8.522H52.2a1.065,1.065,0,1,0,0-2.131H50.069c-.018,0-.033.01-.051.011L47.877,8.391H61.788V21.175Z",
    transform: "translate(-0.001 -0.115)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7960",
    "data-name": "Path 7960",
    d: "M55.2,9.884H53.065a1.065,1.065,0,0,0,0,2.131H55.2a1.065,1.065,0,1,0,0-2.131Z",
    transform: "translate(3.395 0.522)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon01);
export default __webpack_public_path__ + "static/media/development-icon01.7c95cbc6f1599bd27015302820899262.svg";
export { ForwardRef as ReactComponent };